import TimerVerticalTabsDesktopComponent from "segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component";
import ProductTabTitle from "segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-title/product-tab-title";
import { WORK_MANAGEMENT_PRODUCT_ID, CRM_PRODUCT_ID, DEV_PRODUCT_ID } from "constants/products";
import {
  BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
  CRM_DARKER_TINT_02_COLOR_NAME,
  DEV_DARKER_TINT_02_COLOR_NAME
} from "styles/color-consts";
import { useState } from "react";
import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import { componentStyles } from "./products-horizontal-timer-tabs-component.scss";
import DefaultProps from "./default-props";
import ProductTabContentComponent from "./product-tab-content/product-tab-content-component";

const PRODUCT_COLORS_NAMES = {
  [WORK_MANAGEMENT_PRODUCT_ID]: BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
  [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
  [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
const ProductsHorizontalTimerTabsComponent = ({
  tabsTitle,
  contentRenderer,
  overrideTabs,
  progressbarColor,
  renderDesktopTabsOnly,
  ...verticalTimerTabsProps
}) => {
  const [currentProduct, setCurrentProduct] = useState();

  const title = {
    lineHeight: "100%"
  };
  const rightSideRenderer = (currentTab) => {
    // this renders the tab's content
    return <ProductTabContentComponent content={currentTab.tabContent} productType={currentTab.productType} />;
  };

  const tabTitleRenderer = (tabTitle, { isSelected }) => {
    if (!tabTitle) return null;
    return <ProductTabTitle {...tabTitle} isSelected={isSelected} />;
  };

  const onTabChangedHandler = (newTab) => {
    setCurrentProduct(newTab.productType);
  };

  const getTabsProps = () => {
    return overrideTabs || verticalTimerTabsProps;
  };

  const getProgressBarColor = () => {
    return progressbarColor || PRODUCT_COLORS_NAMES[currentProduct] || PRODUCT_COLORS_NAMES[WORK_MANAGEMENT_PRODUCT_ID];
  };

  return (
    <div className="products-horizontal-timer-tabs-component">
      <div className="product-tabs-title-container" style={{ marginBottom: tabsTitle?.titleMarginBottom }}>
        {tabsTitle?.titleText}
      </div>
      {!renderDesktopTabsOnly && (
        <VerticalTimerTabs
          tabTitleRenderer={tabTitleRenderer}
          rightSideRenderer={contentRenderer || rightSideRenderer}
          onTabChangedHandler={onTabChangedHandler}
          progressbarColor={getProgressBarColor()}
          title={title}
          getTabIdentifier={(tab) => tab.productType}
          {...tabsTitle}
          {...verticalTimerTabsProps}
          tabs={getTabsProps()}
        />
      )}
      {renderDesktopTabsOnly && (
        <TimerVerticalTabsDesktopComponent
          tabTitleRenderer={tabTitleRenderer}
          rightSideRenderer={contentRenderer || rightSideRenderer}
          onTabChangedHandler={onTabChangedHandler}
          progressbarColor={getProgressBarColor()}
          title={title}
          getTabIdentifier={(tab) => tab.productType}
          {...tabsTitle}
          {...verticalTimerTabsProps}
          tabs={getTabsProps()}
        />
      )}

      <style jsx>{componentStyles}</style>
    </div>
  );
};

ProductsHorizontalTimerTabsComponent.defaultProps = DefaultProps;

export default ProductsHorizontalTimerTabsComponent;
